import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react"
import { Row, Col, Spin, LucideIcon, message, Button, jsonToQueryString, useCRUDController, Modal } from './ot'
import { useNavigate, useSearchParams, } from "react-router-dom";
import BaseDocumentResponseCanvasEdit from './base_document_response_canvas_edit'
import dayjs from "dayjs";


const BaseCashManagementModal = ({
    setOpen = () => { },
    open = false,
    title = "詳細資訊",
    width = "1200px",
    record,               // ⭐ record.document_id 在這裡
    realTimeApiRoute,     // ⭐ 你傳的 API 在這裡
    axiosMode = "get",
    documentApiRoute = '/cash_management/backend/record_document/view',
    onFinish = ({ axiosMode, status, values }) => { },
}) => {

    const documentId = record?.document_id || null
    const [loading, setLoading] = useState(false)
    const [transactions, setTransactions] = useState([]);


    const modalRender_ = () => {
        const transactionData = {
            summary: {
                totalTransactions: 1247,
                totalAmount: 15678420.50,
                successRate: 98.7,
                avgAmount: 12574.65,
                lastUpdate: "2025-10-12 15:45:32",
            },
            realTime: {
                currentHour: 156,
                currentHourAmount: 1985320.80,
                last5Min: 23,
                last5MinAmount: 287560.40,
            },
            dailyStats: {
                todayTotal: 1247,
                todayAmount: 15678420.50,
                yesterdayTotal: 1189,
                yesterdayAmount: 14523680.20,
                growth: {
                    transactionGrowth: 4.88,
                    amountGrowth: 7.95,
                }
            },
            refunds: {
                totalRefunds: 34,
                totalRefundAmount: 428950.75,
                refundRate: 2.73,
                avgRefundAmount: 12616.20,
            },
            topChannels: [
                { name: "信用卡", count: 524, amount: 6785432.10, percentage: 43.3 },
                { name: "第三方支付", count: 398, amount: 4956780.30, percentage: 31.6 },
                { name: "銀行轉帳", count: 235, amount: 2847295.50, percentage: 18.2 },
            ]
        }

        return (
            <>
                <div className="space-y-6">
                    {/* 即時交易概覽 */}
                    <div className="bg-muted rounded-lg p-4 space-y-3">
                        <div className="flex items-center justify-between">
                            <span className="text-lg font-semibold text-foreground">即時交易統計</span>
                            <span className="text-xs text-muted-foreground flex items-center gap-1">
                                {/* <Clock className="h-3 w-3" /> */}
                                {transactionData.summary?.lastUpdate}
                            </span>
                        </div>
                        
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div className="text-center">
                                <div className="text-2xl font-bold text-blue-600">
                                    {transactionData.summary?.totalTransactions.toLocaleString()}
                                </div>
                                <div className="text-xs text-muted-foreground">今日總筆數</div>
                            </div>
                            <div className="text-center">
                                <div className="text-2xl font-bold text-green-600">
                                    ${transactionData.summary?.totalAmount.toLocaleString('zh-TW', { minimumFractionDigits: 2 })}
                                </div>
                                <div className="text-xs text-muted-foreground">今日總金額</div>
                            </div>
                            <div className="text-center">
                                <div className="text-2xl font-bold text-emerald-600">
                                    {transactionData.summary?.successRate}%
                                </div>
                                <div className="text-xs text-muted-foreground">成功率</div>
                            </div>
                            <div className="text-center">
                                <div className="text-2xl font-bold text-purple-600">
                                    ${transactionData.summary.avgAmount.toLocaleString('zh-TW', { minimumFractionDigits: 2 })}
                                </div>
                                <div className="text-xs text-muted-foreground">平均金額</div>
                            </div>
                        </div>
                    </div>

                    {/* 即時活動 */}
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 space-y-3">
                        <h3 className="text-md font-medium text-foreground">即時活動狀況</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="bg-white rounded p-3">
                                <div className="text-lg font-semibold text-blue-600">
                                    {transactionData.realTime.currentHour}筆
                                </div>
                                <div className="text-sm text-muted-foreground">本小時交易</div>
                                <div className="text-xs text-green-600">
                                    ${transactionData.realTime.currentHourAmount.toLocaleString('zh-TW', { minimumFractionDigits: 2 })}
                                </div>
                            </div>
                            <div className="bg-white rounded p-3">
                                <div className="text-lg font-semibold text-indigo-600">
                                    {transactionData.realTime.last5Min}筆
                                </div>
                                <div className="text-sm text-muted-foreground">最近5分鐘</div>
                                <div className="text-xs text-green-600">
                                    ${transactionData.realTime.last5MinAmount.toLocaleString('zh-TW', { minimumFractionDigits: 2 })}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 日增長比較 */}
                    <div className="bg-muted rounded-lg p-4 space-y-3">
                        <h3 className="text-md font-medium text-foreground">日增長比較</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <div className="text-sm text-muted-foreground mb-1">今日 vs 昨日</div>
                                <div className="flex items-center gap-2">
                                    <span className="text-sm">筆數:</span>
                                    <span className="text-sm font-medium">{transactionData.dailyStats.todayTotal}</span>
                                    <span className={`text-xs px-2 py-1 rounded ${transactionData.dailyStats.growth.transactionGrowth > 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                        {transactionData.dailyStats.growth.transactionGrowth > 0 ? '+' : ''}{transactionData.dailyStats.growth.transactionGrowth}%
                                    </span>
                                </div>
                                <div className="flex items-center gap-2 mt-1">
                                    <span className="text-sm">金額:</span>
                                    <span className="text-sm font-medium">${transactionData.dailyStats.todayAmount.toLocaleString('zh-TW')}</span>
                                    <span className={`text-xs px-2 py-1 rounded ${transactionData.dailyStats.growth.amountGrowth > 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                        {transactionData.dailyStats.growth.amountGrowth > 0 ? '+' : ''}{transactionData.dailyStats.growth.amountGrowth}%
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div className="text-sm text-muted-foreground mb-1">退款統計</div>
                                <div className="text-sm">
                                    <span className="font-medium">{transactionData.refunds.totalRefunds}</span> 筆退款
                                </div>
                                <div className="text-sm">
                                    金額: <span className="font-medium">${transactionData.refunds.totalRefundAmount.toLocaleString('zh-TW', { minimumFractionDigits: 2 })}</span>
                                </div>
                                <div className="text-xs text-muted-foreground">
                                    退款率: {transactionData.refunds.refundRate}%
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 熱門交易渠道 */}
                    <div className="bg-muted rounded-lg p-4 space-y-3">
                        <h3 className="text-md font-medium text-foreground">熱門交易渠道</h3>
                        <div className="space-y-2">
                            {transactionData.topChannels.map((channel, index) => (
                                <div key={index} className="flex items-center justify-between p-2 bg-white rounded">
                                    <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-xs font-semibold">
                                            {index + 1}
                                        </div>
                                        <div>
                                            <div className="text-sm font-medium">{channel.name}</div>
                                            <div className="text-xs text-muted-foreground">
                                                {channel.count} 筆 • {channel.percentage}%
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <div className="text-sm font-semibold text-green-600">
                                            ${channel.amount.toLocaleString('zh-TW', { minimumFractionDigits: 2 })}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </>
        );
    }
    const modalRender = () => {
        if (!transactions) {
            return (
                <div className="p-10 text-center text-muted-foreground">
                    載入中...
                </div>
            );
        }

        const {
            summary,
            realTime,
            dailyStats,
            refunds,
            topChannels = [],
        } = transactions;

        const formatMoney = (v) =>
            v?.toLocaleString("zh-TW", { minimumFractionDigits: 2 }) ?? "0.00";

        return (
            <div className="space-y-6">
                {/* 即時交易統計 */}
                <div className="bg-muted rounded-lg p-4 space-y-3">
                    <div className="flex items-center justify-between">
                        <span className="text-lg font-semibold text-foreground">
                            即時交易統計
                        </span>
                        <span className="text-xs text-muted-foreground">
                            {summary?.lastUpdate}
                        </span>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="text-center">
                            <div className="text-2xl font-bold text-blue-600">
                                {summary?.totalTransactions?.toLocaleString() ?? 0}
                            </div>
                            <div className="text-xs text-muted-foreground">
                                今日總筆數
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-2xl font-bold text-green-600">
                                ${formatMoney(summary?.totalAmount)}
                            </div>
                            <div className="text-xs text-muted-foreground">
                                今日總金額
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-2xl font-bold text-emerald-600">
                                {summary?.successRate ?? 0}%
                            </div>
                            <div className="text-xs text-muted-foreground">
                                成功率
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="text-2xl font-bold text-purple-600">
                                ${formatMoney(summary?.avgAmount)}
                            </div>
                            <div className="text-xs text-muted-foreground">
                                平均金額
                            </div>
                        </div>
                    </div>
                </div>

                {/* 即時活動狀況 */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 space-y-3">
                    <h3 className="text-md font-medium text-foreground">
                        即時活動狀況
                    </h3>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="bg-white rounded p-3">
                            <div className="text-lg font-semibold text-blue-600">
                                {realTime?.currentHour ?? 0}筆
                            </div>
                            <div className="text-sm text-muted-foreground">
                                本小時交易
                            </div>
                            <div className="text-xs text-green-600">
                                ${formatMoney(realTime?.currentHourAmount)}
                            </div>
                        </div>

                        <div className="bg-white rounded p-3">
                            <div className="text-lg font-semibold text-indigo-600">
                                {realTime?.last5Min ?? 0}筆
                            </div>
                            <div className="text-sm text-muted-foreground">
                                最近5分鐘
                            </div>
                            <div className="text-xs text-green-600">
                                ${formatMoney(realTime?.last5MinAmount)}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 日增長比較 + 退款統計 */}
                <div className="bg-muted rounded-lg p-4 space-y-3">
                    <h3 className="text-md font-medium text-foreground">
                        日增長比較
                    </h3>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <div className="text-sm text-muted-foreground mb-1">
                                今日 vs 昨日
                            </div>

                            <div className="flex items-center gap-2">
                                <span className="text-sm">筆數：</span>
                                <span className="text-sm font-medium">
                                    {dailyStats?.todayTotal ?? 0}
                                </span>
                                <span
                                    className={`text-xs px-2 py-1 rounded ${
                                        (dailyStats?.growth?.transactionGrowth ?? 0) >= 0
                                            ? "bg-green-100 text-green-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                >
                                    {dailyStats?.growth?.transactionGrowth ?? 0}%
                                </span>
                            </div>

                            <div className="flex items-center gap-2 mt-1">
                                <span className="text-sm">金額：</span>
                                <span className="text-sm font-medium">
                                    ${formatMoney(dailyStats?.todayAmount)}
                                </span>
                                <span
                                    className={`text-xs px-2 py-1 rounded ${
                                        (dailyStats?.growth?.amountGrowth ?? 0) >= 0
                                            ? "bg-green-100 text-green-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                >
                                    {dailyStats?.growth?.amountGrowth ?? 0}%
                                </span>
                            </div>
                        </div>

                        {/* 退款統計 */}
                        <div>
                            <div className="text-sm text-muted-foreground mb-1">
                                退款統計
                            </div>
                            <div className="text-sm">
                                <span className="font-medium">
                                    {refunds?.totalRefunds ?? 0}
                                </span>{" "}
                                筆退款
                            </div>
                            <div className="text-sm">
                                金額：
                                <span className="font-medium">
                                    ${formatMoney(refunds?.totalRefundAmount)}
                                </span>
                            </div>
                            <div className="text-xs text-muted-foreground">
                                退款率：{refunds?.refundRate ?? 0}%
                            </div>
                        </div>
                    </div>
                </div>

                {/* 熱門交易渠道 */}
                <div className="bg-muted rounded-lg p-4 space-y-3">
                    <h3 className="text-md font-medium text-foreground">
                        熱門交易渠道
                    </h3>

                    <div className="space-y-2">
                        {(topChannels ?? []).map((ch, idx) => (
                            <div
                                key={idx}
                                className="flex items-center justify-between p-2 bg-white rounded"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-xs font-semibold">
                                        {idx + 1}
                                    </div>
                                    <div>
                                        <div className="text-sm font-medium">
                                            {ch.name}
                                        </div>
                                        <div className="text-xs text-muted-foreground">
                                            {ch.count} 筆 • {ch.percentage}%
                                        </div>
                                    </div>
                                </div>

                                <div className="text-right">
                                    <div className="text-sm font-semibold text-green-600">
                                        $
                                        {formatMoney(ch.amount)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };



    const transformDashboard = (rows = []) => {
        const now = dayjs();
        const today = now.startOf("day");
        const yesterday = today.subtract(1, "day");
        const fiveMinutesAgo = now.subtract(5, "minute");

        let todayCount = 0;
        let todayAmount = 0;
        let todaySuccessCount = 0;

        let hourCount = 0;
        let hourAmount = 0;

        let last5mCount = 0;
        let last5mAmount = 0;

        let yesterdayCount = 0;
        let yesterdayAmount = 0;

        let refundCount = 0;
        let refundAmount = 0;

        const channels = {}; // { [channel]: { count, amount } }

        let lastUpdateDate = null;

        const getValue = (item, code) => {
            const f = item.response_form_value_data?.find(
                (v) => v.form_column_form_value_data?.[0]?.code === code
            );
            return f?.value?.value ?? null;
        };

        rows.forEach((row) => {
            const dateStr = getValue(row, "交易日期");
            const amount = Number(getValue(row, "交易金額") || 0);
            const channel = getValue(row, "交易渠道") || "未知";
            const status = getValue(row, "狀態");
            const refund = getValue(row, "是否退款");

            if (!dateStr) return;

            const d = dayjs(dateStr);
            if (!d.isValid()) return;

            // 記錄最後更新時間
            if (!lastUpdateDate || d.isAfter(lastUpdateDate)) {
                lastUpdateDate = d;
            }

            // 今日
            if (d.isSame(today, "day")) {
                todayCount++;
                todayAmount += amount;

                // 小時
                if (d.hour() === now.hour()) {
                    hourCount++;
                    hourAmount += amount;
                }

                // 最近 5 分鐘
                if (d.isAfter(fiveMinutesAgo)) {
                    last5mCount++;
                    last5mAmount += amount;
                }

                // 成功
                if (status === "成功") {
                    todaySuccessCount++;
                }

                // 今日退款
                if (refund === "是") {
                    refundCount++;
                    refundAmount += amount;
                }
            }

            // 昨日
            if (d.isSame(yesterday, "day")) {
                yesterdayCount++;
                yesterdayAmount += amount;
            }

            // 渠道統計（全部筆數）
            if (!channels[channel]) {
                channels[channel] = { count: 0, amount: 0 };
            }
            channels[channel].count++;
            channels[channel].amount += amount;
        });

        const round = (n, d = 2) =>
            Number.isFinite(n) ? Number(n.toFixed(d)) : 0;

        // ---- 組合回傳給 modal 用的結構 ----

        const summary = {
            lastUpdate: lastUpdateDate
                ? lastUpdateDate.format("YYYY-MM-DD HH:mm:ss")
                : now.format("YYYY-MM-DD HH:mm:ss"),
            totalTransactions: todayCount,
            totalAmount: round(todayAmount, 2),
            successRate: todayCount === 0 ? 0 : round((todaySuccessCount / todayCount) * 100, 2),
            avgAmount: todayCount === 0 ? 0 : round(todayAmount / todayCount, 2),
        };

        const realTime = {
            currentHour: hourCount,
            currentHourAmount: round(hourAmount, 2),
            last5Min: last5mCount,
            last5MinAmount: round(last5mAmount, 2),
        };

        const transactionGrowth =
            yesterdayCount === 0
                ? 0
                : round(((todayCount - yesterdayCount) / yesterdayCount) * 100, 2);

        const amountGrowth =
            yesterdayAmount === 0
                ? 0
                : round(((todayAmount - yesterdayAmount) / yesterdayAmount) * 100, 2);

        const dailyStats = {
            todayTotal: todayCount,
            todayAmount: round(todayAmount, 2),
            yesterdayTotal: yesterdayCount,
            yesterdayAmount: round(yesterdayAmount, 2),
            growth: {
                transactionGrowth,
                amountGrowth,
            },
        };

        const refunds = {
            totalRefunds: refundCount,
            totalRefundAmount: round(refundAmount, 2),
            refundRate:
                todayCount === 0 ? 0 : round((refundCount / todayCount) * 100, 2),
        };

        const topChannels = Object.entries(channels)
            .map(([name, obj]) => ({
                name,
                count: obj.count,
                amount: round(obj.amount, 2),
                percentage:
                    todayCount === 0
                        ? 0
                        : round((obj.count / todayCount) * 100, 2),
            }))
            .sort((a, b) => b.amount - a.amount)
            .slice(0, 3);

        return {
            summary,
            realTime,
            dailyStats,
            refunds,
            topChannels,
        };
    };




    const getDocumentData = () => {
        if (!realTimeApiRoute || !documentId) return;

        documentController
            .getData({ document_id: documentId })
            .then((response) => {
                const rows = response?.data || [];
                const dashboard = transformDashboard(rows);
                setTransactions(dashboard);
            })
    };
    const documentController = useCRUDController({
        // apiRoute: documentApiRoute,
        apiRoute: realTimeApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")
                    // setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success("修改成功")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    // setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
                // setModalOpen(false);
            }
        }
    })

    useEffect(() => {
        // getDocumentData()
    }, [])
    useEffect(() => {
        if (open && documentId) {
            getDocumentData();
        }
    }, [open, documentId]);



    return (<>
        <Modal
            confirmLoading={loading}
            title={title}
            open={open}
            // onCancel={onCancel}
            onClose={() => {
                setOpen(false)
            }}
            close={true}
            okProps={{}}
            cancelText="取消"
            closeText="關閉"
            width={width}
        >
            {modalRender()}
        </Modal>
    </>)
}
export default BaseCashManagementModal
